import React, { useState, createContext } from "react";

export const PaginationContext = createContext();

export const PaginationProvider = ({ children }) => {
  const [pagination, setPagination] = useState(0);
  const [fleetPagination, setFleetPagination] = useState(0);
  const [maintainancePagination, setMaintainancePagination] = useState(0);
  const [fuelPagination, setFuelPagination] = useState(0);
  const [fundingPagination, setFundingPagination] = useState(0);

  const contextValue = {
    pagination,
    setPagination,
    fleetPagination,
    setFleetPagination,
    maintainancePagination,
    setMaintainancePagination,
    fuelPagination,
    setFuelPagination,
    fundingPagination,
    setFundingPagination,
  };

  return (
    <PaginationContext.Provider value={contextValue}>
      {children}
    </PaginationContext.Provider>
  );
};
